export default (function() {
  // eslint-disable-next-line no-extend-native
  String.prototype.deleteSpaces = function() {
    if (!this) return '';

    return this.replace(/\s/g, '');
  };

  // eslint-disable-next-line no-extend-native
  String.prototype.getValueWithPenny = function() {
    if (!this) return 0;
    
    const value = this.replace(/\s/g, '');

    return (parseFloat(value) * 10 * 10);
  };
})();
